import { render, staticRenderFns } from "./Insist.vue?vue&type=template&id=06b3e832&scoped=true&"
import script from "./Insist.vue?vue&type=script&lang=js&"
export * from "./Insist.vue?vue&type=script&lang=js&"
import style0 from "./Insist.vue?vue&type=style&index=0&id=06b3e832&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06b3e832",
  null
  
)

export default component.exports